import './error.css';
import type {DrEditionApiError} from '../services/http.ts';

export function renderApiError(error: DrEditionApiError, message = 'An error occurred') {
	return `
<div class="error-message">
	<h1>${message}</h1>
	<h2>${error.status} ${error.title}</h2>
	<p>
		<code>${error.details}</code>
	</p>
</div>
`;
}
